import Vue from 'vue'
import proj4 from 'proj4'

import api from '../../api'
import maps_api from '../../maps_api'

import chunk from '../../../functions/global_functions'

import {
    CREATE_NEW_AD,
    DELETE_AD,
    RESET_AD,
    SET_AD,
    SET_AD_CADASTRAL_REFERENCE,
    SET_AD_CENSUS_SECTION_CODE,
    SET_AD_COUNTRY,
    SET_AD_DATE_CREATED,
    SET_AD_DATE_MODIFIED,
    SET_AD_DESCRIPTION,
    SET_AD_DIRTYNESS,
    SET_AD_DOOR,
    SET_AD_EPSG25831_X,
    SET_AD_EPSG25831_Y,
    SET_AD_FLOOR,
    SET_AD_GEOHASH,
    SET_AD_GOOGLE_FORMATTED_ADDRESS,
    SET_AD_GOOGLE_VIEWPORT,
    SET_AD_ID,
    SET_AD_LAT,
    SET_AD_LNG,
    SET_AD_MUNICIPALITY,
    SET_AD_PARENT_PATH,
    SET_AD_PATH,
    SET_AD_POSTAL_CODE,
    SET_AD_PROVINCE,
    SET_AD_STAIRCASE,
    SET_AD_STREET_NAME,
    SET_AD_STREET_NUMBER,
    UPDATE_AD,

    SET_AD_CADASTRAL_AREA,
    SET_AD_REGISTRY_IDUFIR,
    SET_AD_AD_DATE,
    SET_AD_AD_TYPE,
    SET_AD_AD_YEAR,
    SET_AD_ADOPTED_AREA,
    SET_AD_ADOPTED_AGE,
    SET_AD_AIR_CONDITIONING,
    SET_AD_BATHROOMS_NUMBER,
    SET_AD_BEDROOMS_NUMBER,
    SET_AD_COVERED_OUTDOOR_AREA,
    SET_AD_UNCOVERED_OUTDOOR_AREA,
    SET_AD_CONSTRUCTION_YEAR,
    SET_AD_DWELLING_TYPE,
    SET_AD_ESTIMATED_SALE_PRICE,
    SET_AD_EXTERNAL_STORAGE_ROOM,
    SET_AD_FLOOR_NUMBER,
    SET_AD_FLOOR_TYPE,
    SET_AD_GREEN_AREAS,
    SET_AD_HEATING,
    SET_AD_LAST_RENOVATION_YEAR,
    SET_AD_LIFT,
    SET_AD_OFFER_PRICE,
    SET_AD_PARKING_LOTS_NUMBER,
    SET_AD_QUALITY_OF_NEIGHBOURHOOD,
    SET_AD_QUALITY_OF_SITUATION,
    SET_AD_QUALITY_OF_CONSTRUCTION,
    SET_AD_QUALITY_OF_REALESTATE,
    SET_AD_SPORTS_FACILITIES,
    SET_AD_SWIMMING_POOL,

    SET_AD_AD_ADDRESS,
    SET_AD_BUILT_AREA,
    SET_AD_CAPTURE_DATE,
    SET_AD_AD_DATA_TYPE,
    SET_AD_AD_CODE,
    SET_AD_INTERIOR_VISIT_CHECK,
    SET_AD_LAND_AREA,
    SET_AD_NET_AREA,
    SET_AD_CADASTRAL_DATA_CHECK,
    SET_AD_CONTACT_TELEPHONE,
    SET_AD_NOTES_1,
    SET_AD_NOTES_2,
    SET_AD_ORIENTATION,
    SET_AD_PROPERTY_TYPE,
    SET_AD_SOURCE,
    SET_AD_URL,

    SET_AD_BLOCK,
    SET_AD_CONTACT_NAME,
    SET_AD_OFFER_UNIT_PRICE,
    SET_AD_CONSERVATION_STATUS,

    SET_AD_OFFER_PRICE_REDUCTION_PCT,
    SET_AD_ESTIMATED_UNIT_SALE_PRICE,


} from '../../constants'

const default_state = {
    cadastral_reference: null,
    census_section_code: null,
    country: {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    },
    description: null,
    door: null,
    floor: null,
    geohash: null,
    google_formatted_address: null,
    google_viewport: null,
    lat: null,
    lng: null,
    municipality: null,
    postal_code: null,
    province: null,
    staircase: null,
    street_name: null,
    street_number: null,
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    parent_path: null,

    cadastral_area: null,
    registry_idufir: null,
    ad_date: null,
    ad_type: null,
    ad_year: null,
    adopted_area: null,
    adopted_age: null,
    air_conditioning: null,
    bathrooms_number: null,
    bedrooms_number: null,
    covered_outdoor_area: null,
    uncovered_outdoor_area: null,
    construction_year: null,
    dwelling_type: null,
    estimated_sale_price: null,
    external_storage_room: null,
    floor_number: null,
    floor_type: null,
    green_areas: null,
    heating: null,
    last_renovation_year: null,
    lift: null,
    offer_price: null,
    parking_lots_number: null,
    quality_of_neighbourhood: null,
    quality_of_situation: null,
    quality_of_construction: null,
    quality_of_realestate: null,
    sports_facilities: null,
    swimming_pool: null,

    ad_address: null,
    built_area: null,
    capture_date: null,
    ad_data_type: null,
    ad_code: null,
    interior_visit_check: null,
    land_area: null,
    net_area: null,
    cadastral_data_check: null,
    contact_telephone: null,
    notes_1: null,
    notes_2: null,
    orientation: null,
    property_type: null,
    source: null,
    url: null,

    block: null,
    contact_name: null,
    offer_unit_price: null,
    conservation_status: null,

    offer_price_reduction_pct: 0.05,
    estimated_unit_sale_price: null,



}

const state = default_state

const actions = {

    CREATE_NEW_AD: ({state, commit, rootState}, data) => {

        // 1- crear un new ad en un lloc temporal i quan s'editi es puja al lloc que li toca.

        return new Promise((resolve, reject) => {
            api.create({path: data.path})
                .then((res) => {
                    const new_created_key = res.key

                    commit(SET_AD_ID, new_created_key)
                    commit(SET_AD_DATE_CREATED, res.date_created)
                    commit(SET_AD_DATE_MODIFIED, res.date_modified)
                    commit(SET_AD_PATH, res.path)

                    api.set_value({
                        value: new_created_key,
                        path: data.path + new_created_key + '/' + 'id',
                        save_timestamp: false
                    }).then((res) => {
                            resolve({key: new_created_key})
                    })
                })

        })

    },
    DELETE_AD: ({state, commit, rootState}, data) => {

        console.log('path check: ' + data.path)
        console.log('parent_path check: ' + data.parent_path)

        // delete from contact_addresses/contact_key
        api.delete({key: data.key, path: data.path})
            .then((res) => {


                // delete from contact/contact_key/ads
                api.delete({key: data.key, path: data.parent_path + '/' + data.key})
                    .then((res) => {
                        commit(RESET_AD)

                    })
            })

    },
    SET_AD: ({state, commit, rootState}, data) => {

        // console.log('SET_AD data.path:')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                // console.log('ad.js api.get res:')
                // console.log(res)
                commit(SET_AD, res)
            })

    },
    GEOLOCATE_AD: ({state, commit, rootState}, data) => {

        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return maps_api.geolocate(data)
            .then((res) => {
                console.log(res.results)
                const result = window.confirm(Vue.i18n.translate('S\'ha trobat via Google la següent adreça: ') + res.formatted_address + '. S\'actualitzaran les dades de geolocalització segons aquesta adreça. És correcte?')

                if (result) {

                    const new_lat = res.lat
                    const new_lng = res.lng

                    commit(SET_AD_GOOGLE_FORMATTED_ADDRESS, res.formatted_address)
                    commit(SET_AD_GOOGLE_VIEWPORT, res.viewport)
                    commit(SET_AD_LAT, new_lat)
                    commit(SET_AD_LNG, new_lng)
                    commit(SET_AD_POSTAL_CODE, res.postal_code)
                    commit(SET_AD_STREET_NAME, res.street_name)
                    commit(SET_AD_STREET_NUMBER, res.street_number)

                    const proj4_wgs84 = '+proj=longlat +datum=WGS84 +no_defs'
                    const proj4_epsg25831 = '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs '

                    const epsg25831_coords = proj4(proj4_wgs84, proj4_epsg25831, [res.lng, res.lat])
                    // console.log('epsg25831_coords: ')
                    // console.log(epsg25831_coords)
                    commit(SET_AD_EPSG25831_X, epsg25831_coords[0])
                    commit(SET_AD_EPSG25831_Y, epsg25831_coords[1])

                    if (data.old_geohash) {

                        const old_location_path = 'ad_locations/' + chunk(data.old_geohash, 1).join('/') + '/' + data.id

                        console.log('old_location_path: ')
                        console.log(old_location_path)

                        api.delete({path: old_location_path}).then((res) => {

                            api.getGeohash({key: data.id, lat: new_lat, lng: new_lng}).then((res) => {
                                // console.log('ad.js api.get res:')
                                // console.log(res)
                                const new_geohash = res.geohash

                                const new_location_path = 'ad_locations/' + chunk(new_geohash, 1).join('/')
                                const new_object = {}
                                new_object[data.id] = true

                                api.set_value({
                                    value: new_object,
                                    path: new_location_path,
                                    save_timestamp: false
                                }).then((res) => {
                                    commit(SET_AD_GEOHASH, new_geohash)
                                })

                            })

                        })
                    } else {

                        api.getGeohash({key: data.id, lat: res.lat, lng: res.lng}).then((res) => {
                            // console.log('ad.js api.get res:')
                            // console.log(res)
                            const new_geohash = res.geohash

                            const new_location_path = 'ad_locations/' + chunk(new_geohash, 1).join('/')
                            const new_object = {}
                            new_object[data.id] = true

                            api.set_value({
                                value: new_object,
                                path: new_location_path,
                                save_timestamp: false
                            }).then((res) => {
                                commit(SET_AD_GEOHASH, new_geohash)
                            })

                        })

                    }

                }

            })

    },
    REQUEST_CENSUS_SECTION_INFO: ({state, commit, rootState}, data) => {

        return maps_api.request_icc_census_section_info(data)
            .then((res) => {

                console.log('request_census_section_info res:')
                console.log(res)

                // parse the html response from ICC
                const div = document.createElement('div')
                div.innerHTML = res.html
                const ths = div.querySelectorAll('th')
                const tds = div.querySelectorAll('td')

                // console.log('div: ')
                // console.log(div)

                let new_ths = []
                let new_tds = []

                for (let i = 0; i < ths.length; i++) {
                    new_ths.push(ths[i].innerText.toLowerCase())
                }

                for (let i = 0; i < tds.length; i++) {
                    new_tds.push(tds[i].innerText.toLowerCase())
                }

                console.log('new_ths: ')
                console.log(new_ths)
                console.log('new_tds: ')
                console.log(new_tds)

                let census_obj = Object.assign({}, ...new_ths.map((n, index) => ({[n]: new_tds[index]})))

                // console.log(census_obj)

                const census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio

                commit(SET_AD_CENSUS_SECTION_CODE, census_section_code)

            })

    },
    REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES: ({state, commit, rootState}, data) => {

        return maps_api.request_cadastral_reference_by_coordinates(data)
            .then((res) => {

                console.log('request_cadastral_reference_by_coordinates res:')
                console.log(res)

                if (res.result.consulta_coordenadas_distancias) {
                    const cadref_part1 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc1
                    const cadref_part2 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc2

                    const cadref = cadref_part1 + cadref_part2

                    commit(SET_AD_CADASTRAL_REFERENCE, cadref)
                } else {
                    console.log('res.result.consulta_coordenadas_distancias .... is undefined?')
                }

            })

    },
    RESET_AD: ({state, commit, rootState}) => {
        commit(RESET_AD)
    },
    SET_AD_CADASTRAL_REFERENCE: ({state, commit, rootState}, data) => {
        commit(SET_AD_CADASTRAL_REFERENCE, data)
    },
    SET_AD_CENSUS_SECTION_CODE: ({state, commit, rootState}, data) => {
        commit(SET_AD_CENSUS_SECTION_CODE, data)
    },
    SET_AD_COUNTRY: ({state, commit, rootState}, data) => {
        commit(SET_AD_COUNTRY, data)
    },
    SET_AD_DATE_CREATED: ({state, commit, rootState}, data) => {
        commit(SET_AD_DATE_CREATED, data)
    },
    SET_AD_DATE_MODIFIED: ({state, commit, rootState}, data) => {
        commit(SET_AD_DATE_MODIFIED, data)
    },
    SET_AD_DESCRIPTION: ({state, commit, rootState}, data) => {
        commit(SET_AD_DESCRIPTION, data)
    },
    SET_AD_DOOR: ({state, commit, rootState}, data) => {
        commit(SET_AD_DOOR, data)
    },
    SET_AD_EPSG25831_X: ({state, commit, rootState}, data) => {
        commit(SET_AD_EPSG25831_X, data)
    },
    SET_AD_EPSG25831_Y: ({state, commit, rootState}, data) => {
        commit(SET_AD_EPSG25831_Y, data)
    },
    SET_AD_FLOOR: ({state, commit, rootState}, data) => {
        commit(SET_AD_FLOOR, data)
    },
    SET_AD_GEOHASH: ({state, commit, rootState}, data) => {
        commit(SET_AD_GEOHASH, data)
    },
    SET_AD_GOOGLE_FORMATTED_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_AD_GOOGLE_FORMATTED_ADDRESS, data)
    },
    SET_AD_ID: ({state, commit, rootState}, data) => {
        commit(SET_AD_ID, data)
    },
    SET_AD_LAT: ({state, commit, rootState}, data) => {
        commit(SET_AD_LAT, data)
    },
    SET_AD_LNG: ({state, commit, rootState}, data) => {
        commit(SET_AD_LNG, data)
    },
    SET_AD_MUNICIPALITY: ({state, commit, rootState}, data) => {
        commit(SET_AD_MUNICIPALITY, data)
    },
    SET_AD_POSTAL_CODE: ({state, commit, rootState}, data) => {
        commit(SET_AD_POSTAL_CODE, data)
    },
    SET_AD_PARENT_PATH: ({state, commit, rootState}, data) => {
        commit(SET_AD_PARENT_PATH, data)
    },
    SET_AD_PATH: ({state, commit, rootState}, data) => {
        commit(SET_AD_PATH, data)
    },
    SET_AD_PROVINCE: ({state, commit, rootState}, data) => {
        commit(SET_AD_PROVINCE, data)
    },
    SET_AD_STAIRCASE: ({state, commit, rootState}, data) => {
        commit(SET_AD_STAIRCASE, data)
    },
    SET_AD_STREET_NAME: ({state, commit, rootState}, data) => {
        commit(SET_AD_STREET_NAME, data)
    },
    SET_AD_STREET_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_AD_STREET_NUMBER, data)
    },
    UPDATE_AD: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.update({object: data.object, path: data.path, save_timestamp: true})
                .then((res) => {
                    const date_modified = res.date_modified

                    commit(SET_AD_DATE_MODIFIED, res.date_modified)
                    commit(SET_AD_DIRTYNESS, false)

                    api.update({object: data.object, path: data.path_ads, save_timestamp: true})
                        .then((res) => {
                            api.update({object: data.object, path: data.path_ad_locations, save_timestamp: true})
                                .then((res) => {

                                })
                        })
                })



        })
    },
    SET_AD_CADASTRAL_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_CADASTRAL_AREA, data)
    },
    SET_AD_REGISTRY_IDUFIR: ({state, commit, rootState}, data) => {
        commit(SET_AD_REGISTRY_IDUFIR, data)
    },
    SET_AD_AD_DATE: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_DATE, data)
    },
    SET_AD_AD_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_TYPE, data)
    },
    SET_AD_AD_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_YEAR, data)
    },
    SET_AD_ADOPTED_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_ADOPTED_AREA, data)
    },
    SET_AD_ADOPTED_AGE: ({state, commit, rootState}, data) => {
        commit(SET_AD_ADOPTED_AGE, data)
    },
    SET_AD_AIR_CONDITIONING: ({state, commit, rootState}, data) => {
        commit(SET_AD_AIR_CONDITIONING, data)
    },
    SET_AD_BATHROOMS_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_AD_BATHROOMS_NUMBER, data)
    },
    SET_AD_BEDROOMS_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_AD_BEDROOMS_NUMBER, data)
    },
    SET_AD_COVERED_OUTDOOR_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_COVERED_OUTDOOR_AREA, data)
    },
    SET_AD_UNCOVERED_OUTDOOR_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_UNCOVERED_OUTDOOR_AREA, data)
    },
    SET_AD_CONSTRUCTION_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_AD_CONSTRUCTION_YEAR, data)
    },
    SET_AD_DWELLING_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_AD_DWELLING_TYPE, data)
    },
    SET_AD_ESTIMATED_SALE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_AD_ESTIMATED_SALE_PRICE, data)
    },
    SET_AD_EXTERNAL_STORAGE_ROOM: ({state, commit, rootState}, data) => {
        commit(SET_AD_EXTERNAL_STORAGE_ROOM, data)
    },
    SET_AD_FLOOR_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_AD_FLOOR_NUMBER, data)
    },
    SET_AD_FLOOR_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_AD_FLOOR_TYPE, data)
    },
    SET_AD_GREEN_AREAS: ({state, commit, rootState}, data) => {
        commit(SET_AD_GREEN_AREAS, data)
    },
    SET_AD_HEATING: ({state, commit, rootState}, data) => {
        commit(SET_AD_HEATING, data)
    },
    SET_AD_LAST_RENOVATION_YEAR: ({state, commit, rootState}, data) => {
        commit(SET_AD_LAST_RENOVATION_YEAR, data)
    },
    SET_AD_LIFT: ({state, commit, rootState}, data) => {
        commit(SET_AD_LIFT, data)
    },
    SET_AD_OFFER_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_AD_OFFER_PRICE, data)
    },
    SET_AD_PARKING_LOTS_NUMBER: ({state, commit, rootState}, data) => {
        commit(SET_AD_PARKING_LOTS_NUMBER, data)
    },
    SET_AD_QUALITY_OF_NEIGHBOURHOOD: ({state, commit, rootState}, data) => {
        commit(SET_AD_QUALITY_OF_NEIGHBOURHOOD, data)
    },
    SET_ENTITY_QUALITY_OF_NEIGHBOURHOOD: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            api.set_value({
                value: data.value,
                path: 'appraisal_rooms' + '/' + data.appraisal_id + '/' + data.key + '/' + 'netarea',
                save_timestamp: false
            }).then((res) => {
                resolve()

            })

        })

    },
    SET_AD_QUALITY_OF_SITUATION: ({state, commit, rootState}, data) => {
        commit(SET_AD_QUALITY_OF_SITUATION, data)
    },
    SET_AD_QUALITY_OF_CONSTRUCTION: ({state, commit, rootState}, data) => {
        commit(SET_AD_QUALITY_OF_CONSTRUCTION, data)
    },
    SET_AD_QUALITY_OF_REALESTATE: ({state, commit, rootState}, data) => {
        commit(SET_AD_QUALITY_OF_REALESTATE, data)
    },
    SET_AD_SPORTS_FACILITIES: ({state, commit, rootState}, data) => {
        commit(SET_AD_SPORTS_FACILITIES, data)
    },
    SET_AD_SWIMMING_POOL: ({state, commit, rootState}, data) => {
        commit(SET_AD_SWIMMING_POOL, data)
    },
    SET_AD_AD_ADDRESS: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_ADDRESS, data)
    },
    SET_AD_BUILT_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_BUILT_AREA, data)
    },
    SET_AD_CAPTURE_DATE: ({state, commit, rootState}, data) => {
        commit(SET_AD_CAPTURE_DATE, data)
    },
    SET_AD_AD_DATA_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_DATA_TYPE, data)
    },
    SET_AD_AD_CODE: ({state, commit, rootState}, data) => {
        commit(SET_AD_AD_CODE, data)
    },
    SET_AD_INTERIOR_VISIT_CHECK: ({state, commit, rootState}, data) => {
        commit(SET_AD_INTERIOR_VISIT_CHECK, data)
    },
    SET_AD_LAND_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_LAND_AREA, data)
    },
    SET_AD_NET_AREA: ({state, commit, rootState}, data) => {
        commit(SET_AD_NET_AREA, data)
    },
    SET_AD_CADASTRAL_DATA_CHECK: ({state, commit, rootState}, data) => {
        commit(SET_AD_CADASTRAL_DATA_CHECK, data)
    },
    SET_AD_CONTACT_TELEPHONE: ({state, commit, rootState}, data) => {
        commit(SET_AD_CONTACT_TELEPHONE, data)
    },
    SET_AD_NOTES_1: ({state, commit, rootState}, data) => {
        commit(SET_AD_NOTES_1, data)
    },
    SET_AD_NOTES_2: ({state, commit, rootState}, data) => {
        commit(SET_AD_NOTES_2, data)
    },
    SET_AD_ORIENTATION: ({state, commit, rootState}, data) => {
        commit(SET_AD_ORIENTATION, data)
    },
    SET_AD_PROPERTY_TYPE: ({state, commit, rootState}, data) => {
        commit(SET_AD_PROPERTY_TYPE, data)
    },
    SET_AD_SOURCE: ({state, commit, rootState}, data) => {
        commit(SET_AD_SOURCE, data)
    },
    SET_AD_URL: ({state, commit, rootState}, data) => {
        commit(SET_AD_URL, data)
    },
    SET_AD_BLOCK: ({state, commit, rootState}, data) => {
        commit(SET_AD_BLOCK, data)
    },
    SET_AD_CONTACT_NAME: ({state, commit, rootState}, data) => {
        commit(SET_AD_CONTACT_NAME, data)
    },
    SET_AD_OFFER_UNIT_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_AD_OFFER_UNIT_PRICE, data)
    },
    SET_AD_CONSERVATION_STATUS: ({state, commit, rootState}, data) => {
        commit(SET_AD_CONSERVATION_STATUS, data)
    },
    SET_AD_OFFER_PRICE_REDUCTION_PCT: ({state, commit, rootState}, data) => {
        commit(SET_AD_OFFER_PRICE_REDUCTION_PCT, data)
    },
    SET_AD_ESTIMATED_UNIT_SALE_PRICE: ({state, commit, rootState}, data) => {
        commit(SET_AD_ESTIMATED_UNIT_SALE_PRICE, data)
    },
}

const mutations = {

    [RESET_AD] (state) {
        state.block = null
        state.cadastral_reference = null
        state.census_section_code = null
        state.country = {
            iso_3166_alpha2_code: 'ES',
            name_en: 'Spain'
        }
        state.description = null
        state.door = null
        state.floor = null
        state.geohash = null
        state.google_formatted_address = null
        state.google_viewport = null
        state.lat = null
        state.lng = null
        state.municipality = null
        state.postal_code = null
        state.province = null
        state.staircase = null
        state.street_name = null
        state.street_number = null
        state.type = null
        state.date_created = null
        state.date_modified = null
        state.dirty = false
        state.id = null
        state.path = null
        state.parent_path = null

        state.cadastral_area = null
        state.registry_idufir = null
        state.ad_date = null
        state.ad_type = null
        state.ad_year = null
        state.adopted_area = null
        state.adopted_age = null
        state.air_conditioning = null
        state.bathrooms_number = null
        state.bedrooms_number = null
        state.covered_outdoor_area = null
        state.uncovered_outdoor_area = null
        state.construction_year = null
        state.dwelling_type = null
        state.estimated_sale_price = null
        state.external_storage_room = null
        state.floor_number = null
        state.floor_type = null
        state.green_areas = null
        state.heating = null
        state.last_renovation_year = null
        state.lift = null
        state.offer_price = null
        state.parking_lots_number = null
        state.quality_of_neighbourhood = null
        state.quality_of_situation = null
        state.quality_of_construction = null
        state.quality_of_realestate = null
        state.sports_facilities = null
        state.swimming_pool = null

        state.ad_address = null
        state.built_area = null
        state.capture_date = null
        state.ad_data_type = null
        state.ad_code = null
        state.interior_visit_check = null
        state.land_area = null
        state.net_area = null
        state.cadastral_data_check = null
        state.contact_telephone = null
        state.notes_1 = null
        state.notes_2 = null
        state.orientation = null
        state.property_type = null
        state.source = null
        state.url = null

        state.block = null
        state.contact_name = null
        state.offer_unit_price = null
        state.conservation_status = null

        state.offer_price_reduction_pct = 0.05

        state.estimated_unit_sale_price = null


    },
    [SET_AD] (state, data) {
        // console.log('mutations SET_CONTACT data: ')
        // console.log(data)
        state.block = check_undefined(data.block)
        state.cadastral_reference = check_undefined(data.cadastral_reference)
        state.census_section_code = check_undefined(data.census_section_code)
        state.description = check_undefined(data.description)
        state.door = check_undefined(data.door)
        state.epsg25831_x = check_undefined(data.epsg25831_x)
        state.epsg25831_y = check_undefined(data.epsg25831_y)
        state.floor = check_undefined(data.floor)
        state.geohash = check_undefined(data.geohash)
        state.google_formatted_address = check_undefined(data.google_formatted_address)
        state.lat = check_undefined(data.lat)
        state.lng = check_undefined(data.lng)
        state.municipality = check_undefined(data.municipality)
        state.postal_code = check_undefined(data.postal_code)
        state.province = check_undefined(data.province)
        state.staircase = check_undefined(data.staircase)
        state.street_name = check_undefined(data.street_name)
        state.street_number = check_undefined(data.street_number)
        state.type = check_undefined(data.type)

        //general data
        state.date_created = check_undefined(data.date_created)
        state.date_modified = check_undefined(data.date_modified)
        state.dirty = false
        state.id = check_undefined(data.id)
        state.path = check_undefined(data.path)
        state.parent_path = check_undefined(data.parent_path)

        //
        state.cadastral_area = check_undefined(data.cadastral_area)
        state.registry_idufir = check_undefined(data.registry_idufir)
        state.ad_date = check_undefined(data.ad_date)
        state.ad_type = check_undefined(data.ad_type)
        state.ad_year = check_undefined(data.ad_year)
        state.adopted_area = check_undefined(data.adopted_area)
        state.adopted_age = check_undefined(data.adopted_age)
        state.air_conditioning = check_undefined(data.air_conditioning)
        state.bathrooms_number = check_undefined(data.bathrooms_number)
        state.bedrooms_number = check_undefined(data.bedrooms_number)
        state.covered_outdoor_area = check_undefined(data.covered_outdoor_area)
        state.uncovered_outdoor_area = check_undefined(data.uncovered_outdoor_area)
        state.construction_year = check_undefined(data.construction_year)
        state.dwelling_type = check_undefined(data.dwelling_type)
        state.estimated_sale_price = check_undefined(data.estimated_sale_price)
        state.external_storage_room = check_undefined(data.external_storage_room)
        state.floor_number = check_undefined(data.floor_number)
        state.floor_type = check_undefined(data.floor_type)
        state.green_areas = check_undefined(data.green_areas)
        state.heating = check_undefined(data.heating)
        state.last_renovation_year = check_undefined(data.last_renovation_year)
        state.lift = check_undefined(data.lift)
        state.offer_price = check_undefined(data.offer_price)
        state.parking_lots_number = check_undefined(data.parking_lots_number)
        state.quality_of_neighbourhood = check_undefined(data.quality_of_neighbourhood)
        state.quality_of_situation = check_undefined(data.quality_of_situation)
        state.quality_of_construction = check_undefined(data.quality_of_construction)
        state.quality_of_realestate = check_undefined(data.quality_of_realestate)
        state.sports_facilities = check_undefined(data.sports_facilities)
        state.swimming_pool = check_undefined(data.swimming_pool)

        state.ad_address = check_undefined(data.ad_address)
        state.built_area = check_undefined(data.built_area)
        state.capture_date = check_undefined(data.capture_date)
        state.ad_data_type = check_undefined(data.ad_data_type)
        state.ad_code = check_undefined(data.ad_code)
        state.interior_visit_check = check_undefined(data.interior_visit_check)
        state.land_area = check_undefined(data.land_area)
        state.net_area = check_undefined(data.net_area)
        state.cadastral_data_check = check_undefined(data.cadastral_data_check)
        state.contact_telephone = check_undefined(data.contact_telephone)
        state.notes_1 = check_undefined(data.notes_1)
        state.notes_2 = check_undefined(data.notes_2)
        state.orientation = check_undefined(data.orientation)
        state.property_type = check_undefined(data.property_type)
        state.source = check_undefined(data.source)
        state.url = check_undefined(data.url)

        state.block = check_undefined(data.block)
        state.contact_name = check_undefined(data.contact_name)
        state.offer_unit_price = check_undefined(data.offer_unit_price)
        state.conservation_status = check_undefined(data.conservation_status)

        state.offer_price_reduction_pct = check_undefined(data.offer_price_reduction_pct)
        state.estimated_unit_sale_price = check_undefined(data.estimated_unit_sale_price)


    },
    [SET_AD_CADASTRAL_REFERENCE] (state, data) {
        state.cadastral_reference = data
        state.dirty = true
    },
    [SET_AD_CENSUS_SECTION_CODE] (state, data) {
        state.census_section_code = data
        state.dirty = true
    },
    [SET_AD_COUNTRY] (state, data) {
        state.country = data
        state.dirty = true
    },
    [SET_AD_DATE_CREATED] (state, data) {
        state.date_created = data
        state.dirty = true
    },
    [SET_AD_DATE_MODIFIED] (state, data) {
        state.date_modified = data
        state.dirty = true
    },
    [SET_AD_DESCRIPTION] (state, data) {
        state.description = data
        state.dirty = true
    },
    [SET_AD_DIRTYNESS] (state, boolean) {
        state.dirty = boolean
    },
    [SET_AD_DOOR] (state, data) {
        state.door = data
        state.dirty = true
    },
    [SET_AD_FLOOR] (state, data) {
        state.floor = data
        state.dirty = true
    },
    [SET_AD_GEOHASH] (state, data) {
        state.geohash = data
        state.dirty = true
    },
    [SET_AD_GOOGLE_FORMATTED_ADDRESS] (state, data) {
        state.google_formatted_address = data
        state.dirty = true
    },
    [SET_AD_GOOGLE_VIEWPORT] (state, data) {
        state.google_viewport = data
        state.dirty = true
    },
    [SET_AD_EPSG25831_X] (state, data) {
        state.epsg25831_x = data
        state.dirty = true
    },
    [SET_AD_EPSG25831_Y] (state, data) {
        state.epsg25831_y = data
        state.dirty = true
    },
    [SET_AD_ID] (state, data) {
        state.id = data
        state.dirty = true
    },
    [SET_AD_LAT] (state, data) {
        state.lat = data
        state.dirty = true
    },
    [SET_AD_LNG] (state, data) {
        state.lng = data
        state.dirty = true
    },
    [SET_AD_MUNICIPALITY] (state, data) {
        state.municipality = data
        state.dirty = true
    },
    [SET_AD_PARENT_PATH] (state, data) {
        state.parent_path = data
        state.dirty = true
    },
    [SET_AD_PATH] (state, data) {
        state.path = data
        state.dirty = true
    },
    [SET_AD_POSTAL_CODE] (state, data) {
        state.postal_code = data
        state.dirty = true
    },
    [SET_AD_PROVINCE] (state, data) {
        state.province = data
        state.dirty = true
    },
    [SET_AD_STAIRCASE] (state, data) {
        state.staircase = data
        state.dirty = true
    },
    [SET_AD_STREET_NAME] (state, data) {
        state.street_name = data
        state.dirty = true
    },
    [SET_AD_STREET_NUMBER] (state, data) {
        state.street_number = data
        state.dirty = true
    },

    [SET_AD_CADASTRAL_AREA] (state, data) {
        state.cadastral_area = data
        state.dirty = true
    },
    [SET_AD_REGISTRY_IDUFIR] (state, data) {
        state.registry_idufir = data
        state.dirty = true
    },
    [SET_AD_AD_DATE] (state, data) {
        state.ad_date = data
        state.dirty = true
    },
    [SET_AD_AD_TYPE] (state, data) {
        state.ad_type = data
        state.dirty = true
    },
    [SET_AD_AD_YEAR] (state, data) {
        state.ad_year = data
        state.dirty = true
    },
    [SET_AD_ADOPTED_AREA] (state, data) {
        state.adopted_area = data
        state.dirty = true
    },
    [SET_AD_ADOPTED_AGE] (state, data) {
        state.adopted_age = data
        state.dirty = true
    },
    [SET_AD_AIR_CONDITIONING] (state, data) {
        state.air_conditioning = data
        state.dirty = true
    },
    [SET_AD_BATHROOMS_NUMBER] (state, data) {
        state.bathrooms_number = data
        state.dirty = true
    },
    [SET_AD_BEDROOMS_NUMBER] (state, data) {
        state.bedrooms_number = data
        state.dirty = true
    },
    [SET_AD_CONSERVATION_STATUS] (state, data) {
        state.conservation_status = data
        state.dirty = true
    },
    [SET_AD_COVERED_OUTDOOR_AREA] (state, data) {
        state.covered_outdoor_area = data
        state.dirty = true
    },
    [SET_AD_UNCOVERED_OUTDOOR_AREA] (state, data) {
        state.uncovered_outdoor_area = data
        state.dirty = true
    },
    [SET_AD_CONSTRUCTION_YEAR] (state, data) {
        state.construction_year = data
        state.dirty = true
    },
    [SET_AD_DWELLING_TYPE] (state, data) {
        state.dwelling_type = data
        state.dirty = true
    },
    [SET_AD_ESTIMATED_SALE_PRICE] (state, data) {
        state.estimated_sale_price = data
        state.dirty = true
    },
    [SET_AD_EXTERNAL_STORAGE_ROOM] (state, data) {
        state.external_storage_room = data
        state.dirty = true
    },
    [SET_AD_FLOOR_NUMBER] (state, data) {
        state.floor_number = data
        state.dirty = true
    },
    [SET_AD_FLOOR_TYPE] (state, data) {
        state.floor_type = data
        state.dirty = true
    },
    [SET_AD_GREEN_AREAS] (state, data) {
        state.green_areas = data
        state.dirty = true
    },
    [SET_AD_HEATING] (state, data) {
        state.heating = data
        state.dirty = true
    },
    [SET_AD_LAST_RENOVATION_YEAR] (state, data) {
        state.last_renovation_year = data
        state.dirty = true
    },
    [SET_AD_LIFT] (state, data) {
        state.lift = data
        state.dirty = true
    },
    [SET_AD_OFFER_PRICE] (state, data) {
        state.offer_price = data
        state.dirty = true
    },
    [SET_AD_PARKING_LOTS_NUMBER] (state, data) {
        state.parking_lots_number = data
        state.dirty = true
    },
    [SET_AD_QUALITY_OF_NEIGHBOURHOOD] (state, data) {
        state.quality_of_neighbourhood = data
        state.dirty = true
    },
    [SET_AD_QUALITY_OF_SITUATION] (state, data) {
        state.quality_of_situation = data
        state.dirty = true
    },
    [SET_AD_QUALITY_OF_CONSTRUCTION] (state, data) {
        state.quality_of_construction = data
        state.dirty = true
    },
    [SET_AD_QUALITY_OF_REALESTATE] (state, data) {
        state.quality_of_realestate = data
        state.dirty = true
    },
    [SET_AD_SPORTS_FACILITIES] (state, data) {
        state.sports_facilities = data
        state.dirty = true
    },
    [SET_AD_SWIMMING_POOL] (state, data) {
        state.swimming_pool = data
        state.dirty = true
    },
    [SET_AD_AD_ADDRESS] (state, data) {
        state.ad_address = data
        state.dirty = true
    },
    [SET_AD_BUILT_AREA] (state, data) {
        state.built_area = data
        state.dirty = true
    },
    [SET_AD_CAPTURE_DATE] (state, data) {
        state.capture_date = data
        state.dirty = true
    },
    [SET_AD_AD_DATA_TYPE] (state, data) {
        state.ad_data_type = data
        state.dirty = true
    },
    [SET_AD_AD_CODE] (state, data) {
        state.ad_code = data
        state.dirty = true
    },
    [SET_AD_INTERIOR_VISIT_CHECK] (state, data) {
        state.interior_visit_check = data
        state.dirty = true
    },
    [SET_AD_LAND_AREA] (state, data) {
        state.land_area = data
        state.dirty = true
    },
    [SET_AD_NET_AREA] (state, data) {
        state.net_area = data
        state.dirty = true
    },
    [SET_AD_CADASTRAL_DATA_CHECK] (state, data) {
        state.cadastral_data_check = data
        state.dirty = true
    },
    [SET_AD_CONTACT_TELEPHONE] (state, data) {
        state.contact_telephone = data
        state.dirty = true
    },
    [SET_AD_NOTES_1] (state, data) {
        state.notes_1 = data
        state.dirty = true
    },
    [SET_AD_NOTES_2] (state, data) {
        state.notes_2 = data
        state.dirty = true
    },
    [SET_AD_ORIENTATION] (state, data) {
        state.orientation = data
        state.dirty = true
    },
    [SET_AD_PROPERTY_TYPE] (state, data) {
        state.property_type = data
        state.dirty = true
    },
    [SET_AD_SOURCE] (state, data) {
        state.source = data
        state.dirty = true
    },
    [SET_AD_URL] (state, data) {
        state.url = data
        state.dirty = true
    },
    [SET_AD_BLOCK] (state, data) {
        state.block = data
        state.dirty = true
    },
    [SET_AD_CONTACT_NAME] (state, data) {
        state.contact_name = data
        state.dirty = true
    },
    [SET_AD_OFFER_UNIT_PRICE] (state, data) {
        state.offer_unit_price = data
        state.dirty = true
    },
    [SET_AD_CONSERVATION_STATUS] (state, data) {
        state.conservation_status = data
        state.dirty = true
    },
    [SET_AD_OFFER_PRICE_REDUCTION_PCT] (state, data) {
        state.offer_price_reduction_pct = data
        state.dirty = true
    },
    [SET_AD_ESTIMATED_UNIT_SALE_PRICE] (state, data) {
        state.estimated_unit_sale_price = data
        state.dirty = true
    },

}

function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

const getters = {

    ad: state => {
        return state
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/ad/ad.js